import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center pt-16 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20marketplace%20concept%20with%20abstract%20geometric%20shapes%20and%20soft%20flowing%20fabric%20textures%20in%20warm%20neutral%20palette%2C%20clean%20modern%20composition%20with%20scattered%20fashion%20silhouettes%20and%20product%20outlines%2C%20contemporary%20digital%20art%20style%2C%20gentle%20gradient%20from%20warm%20beige%20to%20soft%20ivory%2C%20sophisticated%20minimalist%20aesthetic%20with%20subtle%20layered%20transparency%20effects&width=1920&height=1080&seq=hero-bg-v2&orientation=landscape"
          alt="Mulebuy spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center max-w-7xl mx-auto">
          <div className="lg:w-2/5 w-full">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              Best Mulebuy Spreadsheet Guide 2026
            </h1>
            <p className="mt-4 text-lg md:text-xl text-white/80 font-heading font-semibold">
              Find Verified Mulebuy Spreadsheet Lists &amp; Tools
            </p>
            <p className="mt-6 text-sm md:text-base text-white/70 leading-relaxed max-w-lg">
              Discover the most updated and reliable <strong>mulebuy spreadsheet</strong> collections, comparison tools, and buying agent data all in one place. Save time with verified spreadsheet data and avoid unreliable or outdated links.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Link
                to="/article/mulebuy-spreadsheet-guide"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Mulebuy Spreadsheet
                <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center"></i>
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white/20 backdrop-blur-sm text-white font-semibold text-sm border border-white/30 hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="lg:w-3/5 w-full">
            <div className="grid grid-cols-3 gap-3 md:gap-4">
              <div className="col-span-2 row-span-2">
                <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Stylish%20fashion%20flat%20lay%20with%20modern%20sneakers%2C%20leather%20handbag%2C%20watch%2C%20and%20folded%20denim%20arranged%20artistically%20on%20light%20marble%20surface%2C%20soft%20diffused%20studio%20lighting%20with%20subtle%20window%20reflection%2C%20clean%20contemporary%20editorial%20style%2C%20warm%20ivory%20and%20charcoal%20tones%2C%20professional%20product%20styling%20with%20elegant%20scattered%20composition%20and%20negative%20space&width=800&height=1000&seq=hero-main-v2&orientation=portrait"
                    alt="Featured mulebuy spreadsheet products"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute bottom-3 left-3">
                    <span className="px-3 py-1.5 rounded-full bg-white/90 text-foreground-900 text-xs font-medium backdrop-blur-sm">
                      Top Picks
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="block relative rounded-2xl overflow-hidden aspect-square cursor-pointer group">
                  <img
                    src="https://readdy.ai/api/search-image?query=Single%20pair%20of%20premium%20white%20leather%20sneakers%20on%20textured%20stone%20surface%2C%20clean%20minimalist%20product%20photography%2C%20bright%20natural%20daylight%2C%20high-end%20editorial%20style%20with%20crisp%20shadows%2C%20modern%20luxury%20aesthetic%2C%20no%20logos%20no%20text&width=500&height=500&seq=hero-shoes-v2&orientation=squarish"
                    alt="Shoes category"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-2 left-2">
                    <span className="px-2.5 py-1 rounded-full bg-white/90 text-foreground-900 text-xs font-medium backdrop-blur-sm">Shoes</span>
                  </div>
                </a>
              </div>
              <div>
                <a href="https://kaspreadsheet.com/category-921-Bags.html" target="_blank" rel="noopener nofollow" className="block relative rounded-2xl overflow-hidden aspect-square cursor-pointer group">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20structured%20leather%20tote%20bag%20standing%20on%20polished%20concrete%20surface%2C%20clean%20product%20photography%2C%20soft%20directional%20lighting%20creating%20gentle%20shadows%2C%20high-end%20minimalist%20aesthetic%2C%20warm%20taupe%20tones%2C%20no%20text%20no%20logos&width=500&height=500&seq=hero-bags-v2&orientation=squarish"
                    alt="Bags category"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-2 left-2">
                    <span className="px-2.5 py-1 rounded-full bg-white/90 text-foreground-900 text-xs font-medium backdrop-blur-sm">Bags</span>
                  </div>
                </a>
              </div>
              <div>
                <a href="https://kaspreadsheet.com/category-920-Accessories.html" target="_blank" rel="noopener nofollow" className="block relative rounded-2xl overflow-hidden aspect-square cursor-pointer group">
                  <img
                    src="https://readdy.ai/api/search-image?query=Minimalist%20arrangement%20of%20designer%20watch%20and%20thin%20gold%20bracelet%20on%20raw%20linen%20fabric%20surface%2C%20clean%20product%20photography%2C%20soft%20window%20light%2C%20sophisticated%20editorial%20style%2C%20warm%20sand%20and%20metallic%20tones%2C%20elegant%20restrained%20composition%2C%20no%20text%20no%20logos&width=500&height=500&seq=hero-accessories-v2&orientation=squarish"
                    alt="Accessories category"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute bottom-2 left-2">
                    <span className="px-2.5 py-1 rounded-full bg-white/90 text-foreground-900 text-xs font-medium backdrop-blur-sm">Accessories</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}